import { t } from '@/i18n';
import { ColorPicker } from '@/components/common/ColorPicker';

interface DeltaColorsSectionProps {
  deltaColorUp?: string;
  deltaColorDown?: string;
  deltaColorNeutral?: string;
  onChange: (field: string, value: unknown) => void;
  testIdPrefix: string;
}

export function DeltaColorsSection({
  deltaColorUp,
  deltaColorDown,
  deltaColorNeutral,
  onChange,
  testIdPrefix,
}: DeltaColorsSectionProps) {
  return (
    <div>
      <h6>{t('dashboard.widget.labeled_list.section.deltaColors')}</h6>
      <div className="mb-3" data-testid={`${testIdPrefix}-delta-color-up`}>
        <label className="form-label">{t('dashboard.widget.indicator.field.deltaColorUp')}</label>
        <ColorPicker
          value={deltaColorUp ?? ''}
          onChange={(color) => onChange('deltaColorUp', color)}
        />
      </div>
      <div className="mb-3" data-testid={`${testIdPrefix}-delta-color-down`}>
        <label className="form-label">{t('dashboard.widget.indicator.field.deltaColorDown')}</label>
        <ColorPicker
          value={deltaColorDown ?? ''}
          onChange={(color) => onChange('deltaColorDown', color)}
        />
      </div>
      <div className="mb-3" data-testid={`${testIdPrefix}-delta-color-neutral`}>
        <label className="form-label">{t('dashboard.widget.indicator.field.deltaColorNeutral')}</label>
        <ColorPicker
          value={deltaColorNeutral ?? ''}
          onChange={(color) => onChange('deltaColorNeutral', color)}
        />
      </div>
    </div>
  );
}
